// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3N16c","overflowing":"ReadFullNote_overflowing__1QiO3"};